import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: '/',
    component: () => import('../views/Home/Index.vue')
  },
  {
    path: '/pledge',
    component: () => import('../views/Pledge/Index.vue')
  },
  {
    path: '/nft',
    component: () => import('../views/NFT/Index.vue')
  },
  {
    path: '/superApp',
    component: () => import('../views/SuperApp/Index.vue')
  },
  {
    path: '/mine',
    component: () => import('../views/Mine/Index.vue')
  },
  {
    path: '/mine/record',
    component: () => import('../views/Mine/Record.vue')
  },
  {
    path: '/admin/set',
    component: () => import('../views/Set.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router;
